import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { ConsumerProblemFragmentDoc } from '../fragments/problem.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetProblemsQueryVariables = Types.Exact<{
  uuid: Types.Scalars['ID'];
}>;


export type GetProblemsQuery = { __typename?: 'Query', getProblems: Array<{ __typename?: 'Problem', id: string, creation_timestamp: string, event_name: string, event_data: string, store_text_id?: string | null, store_name?: string | null }> };


export const GetProblemsDocument = gql`
    query getProblems($uuid: ID!) {
  getProblems(uuid: $uuid) {
    ...ConsumerProblem
  }
}
    ${ConsumerProblemFragmentDoc}`;

/**
 * __useGetProblemsQuery__
 *
 * To run a query within a React component, call `useGetProblemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProblemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProblemsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetProblemsQuery(baseOptions: Apollo.QueryHookOptions<GetProblemsQuery, GetProblemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProblemsQuery, GetProblemsQueryVariables>(GetProblemsDocument, options);
      }
export function useGetProblemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProblemsQuery, GetProblemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProblemsQuery, GetProblemsQueryVariables>(GetProblemsDocument, options);
        }
export type GetProblemsQueryHookResult = ReturnType<typeof useGetProblemsQuery>;
export type GetProblemsLazyQueryHookResult = ReturnType<typeof useGetProblemsLazyQuery>;
export type GetProblemsQueryResult = Apollo.QueryResult<GetProblemsQuery, GetProblemsQueryVariables>;